import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import vant from './vant' // 该文件为统一配置注册所需的vant组件
import router from './router'
import { message } from 'ant-design-vue'
import { ConfigProvider } from 'ant-design-vue' 
Vue.use(ConfigProvider)

import './theme/theme.less'

Vue.config.productionTip = false

Vue.use(Antd)

Vue.use(vant)

// 全局消息提示去重
message.config({
  top: 100,
  duration: 2,
  maxCount: 1
})
message.destroy()

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})
